"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _CardNavigationItem = _interopRequireDefault(require("./components/CardNavigationItem"));
require("./mobile.css");
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var CardNavigation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CardNavigation, _React$Component);
  var _super = _createSuper(CardNavigation);
  function CardNavigation() {
    (0, _classCallCheck2["default"])(this, CardNavigation);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(CardNavigation, [{
    key: "getStackedMobileOrder",
    value: function getStackedMobileOrder() {
      var items = this.props.items;
      if (this.itemsAreAlternatingImages()) {
        var others = [];
        var images = [];
        items.forEach(function (item) {
          if (item.type === 'image') {
            images.push(item);
          } else {
            others.push(item);
          }
        });
        var mobileItems = [];
        var i = 0;
        while (i < others.length) {
          mobileItems.push(others[i]);
          mobileItems.push(images[i]);
          i += 1;
        }
        return mobileItems;
      }
      return items;
    }
  }, {
    key: "itemsAreAlternatingImages",
    value: function itemsAreAlternatingImages() {
      var _this$props = this.props,
        items = _this$props.items,
        itemsPerRow = _this$props.itemsPerRow;
      if (itemsPerRow === 2 && items.length % 2 === 0) {
        var headerFirst = true;
        if (items[0].type === 'image') {
          headerFirst = false;
        } // eslint-disable-next-line consistent-return

        items.forEach(function (item, index) {
          if (item.type === 'image') {
            var mod = headerFirst ? 1 : 0;
            if (index % 2 !== mod) {
              return false;
            }
          }
        });
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        height = _this$props2.height,
        itemsPerRow = _this$props2.itemsPerRow,
        items = _this$props2.items,
        gutter = _this$props2.gutter,
        rounded = _this$props2.rounded;
      var mobileItems = this.getStackedMobileOrder();
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "desktop-nav"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        verticalAlign: "middle",
        columns: itemsPerRow
      }, items.map(function (_ref) {
        var background = _ref.background,
          content = _ref.content,
          link = _ref.link,
          type = _ref.type;
        return /*#__PURE__*/_react["default"].createElement(_CardNavigationItem["default"], (0, _extends2["default"])({}, link, {
          height: height,
          background: background,
          content: content,
          type: type,
          gutter: gutter || rounded,
          rounded: gutter || rounded
        }));
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mobile-nav"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        verticalAlign: "middle",
        columns: 1
      }, mobileItems.map(function (_ref2) {
        var background = _ref2.background,
          content = _ref2.content,
          link = _ref2.link,
          type = _ref2.type;
        return /*#__PURE__*/_react["default"].createElement(_CardNavigationItem["default"], (0, _extends2["default"])({}, link, {
          height: height,
          background: background,
          content: content,
          type: type,
          gutter: gutter || rounded,
          rounded: gutter || rounded
        }));
      }))));
    }
  }]);
  return CardNavigation;
}(_react["default"].Component);
exports["default"] = CardNavigation;
CardNavigation.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    background: _propTypes["default"].string,
    backgroundType: _propTypes["default"].oneOf(['image', 'color']),
    content: _propTypes["default"].element,
    link: _propTypes["default"].shape({
      slug: _propTypes["default"].string.isRequired,
      internal: _propTypes["default"].bool.isRequired
    }).isRequired
  })).isRequired,
  gutter: _propTypes["default"].bool,
  rounded: _propTypes["default"].bool,
  height: _propTypes["default"].number,
  itemsPerRow: _propTypes["default"].number,
  gatsbyLink: _propTypes["default"].element
};
CardNavigation.defaultProps = {
  gutter: false,
  rounded: false,
  height: 300,
  itemsPerRow: 2,
  gatsbyLink: null
};